const topicItems = [
  { tag: '明星恋情', heat: '987万', trend: 'up', category: '八卦' },
  { tag: '综艺爆料', heat: '856万', trend: 'up', category: '综艺' },
  { tag: '影视资讯', heat: '743万', trend: 'up', category: '影视' },
  { tag: '网红翻车', heat: '698万', trend: 'hot', category: '网红' },
  { tag: '时尚穿搭', heat: '612万', trend: 'up', category: '时尚' },
  { tag: '音乐动态', heat: '534万', trend: 'stable', category: '音乐' },
  { tag: '体育八卦', heat: '487万', trend: 'up', category: '体育' },
  { tag: '直播带货', heat: '456万', trend: 'down', category: '电商' },
  { tag: '选秀节目', heat: '421万', trend: 'up', category: '综艺' },
  { tag: '古装剧集', heat: '389万', trend: 'stable', category: '影视' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-hashtag text-sm"></i>
            话题热榜
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            话题热榜
          </h2>
          <p className="text-foreground-500 text-sm mt-2">实时追踪最热门的吃瓜话题</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer text-center"
            >
              <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                {item.category}
              </span>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {item.tag}
              </h3>
              <div className="flex items-center justify-center gap-2 text-xs">
                <span className="text-accent-600 font-medium">
                  <i className={`ri-fire-line ${item.trend === 'hot' ? 'text-primary-500' : ''} mr-1`}></i>
                  {item.heat}
                </span>
                {item.trend === 'up' && (
                  <span className="text-accent-500">
                    <i className="ri-arrow-up-line text-xs"></i>
                  </span>
                )}
                {item.trend === 'hot' && (
                  <span className="text-primary-500">
                    <i className="ri-fire-line text-xs"></i>
                  </span>
                )}
                {item.trend === 'down' && (
                  <span className="text-foreground-400">
                    <i className="ri-arrow-down-line text-xs"></i>
                  </span>
                )}
                {item.trend === 'stable' && (
                  <span className="text-foreground-400">
                    <i className="ri-subtract-line text-xs"></i>
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}